import React from "react";
import { useLang } from "../contexts/LanguageContext";
import useSiteContent from "../lib/useSiteContent";

export default function AboutPage() {
  const { t, lang } = useLang();
  const about = useSiteContent("about", {});
  const pick = (k, fallback) => about[`${k}_${lang}`] || fallback;
  return (
    <div data-testid="about-page" className="pt-40 lg:pt-44">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="overline text-[#4A6A8F]">{t.about.eyebrow}</div>
        <h1 className="font-serif-ap text-5xl sm:text-6xl lg:text-7xl text-[#0F2746] mt-6 max-w-4xl leading-[1.02] tracking-tight">
          {pick("title", t.about.title)}
        </h1>
      </section>

      <section
        className="h-[60vh] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('https://images.pexels.com/photos/19153641/pexels-photo-19153641.jpeg')" }}
      />

      <section className="bg-[#F6F8FA] py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6 lg:col-start-4">
            <p className="text-[#0F2746] text-lg leading-relaxed">{pick("body1", t.about.body1)}</p>
            <p className="text-[#3A5170] text-base leading-relaxed mt-8">{pick("body2", t.about.body2)}</p>
          </div>
        </div>
      </section>

      <section className="bg-[#EEF1F5] py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="overline text-[#4A6A8F]">{t.about.values_title}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 mt-12">
            {t.about.values.map((v, i) => (
              <div key={v.t} data-testid={`value-${i}`} className="border-t border-[#0F2746]/30 pt-6">
                <div className="font-serif-ap text-3xl text-[#C4A47C]">{String(i + 1).padStart(2, "0")}</div>
                <div className="font-serif-ap text-2xl text-[#0F2746] mt-3">{v.t}</div>
                <div className="text-sm text-[#3A5170] mt-3 leading-relaxed">{v.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
